/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.30/esri/copyright.txt for details.
*/
import{VisualVariablesParameters as s}from"../../layers/support/FastSymbolUpdates.js";import{RenderOccludedFlag as r}from"../lib/Material.js";class t extends s{constructor(){super(...arguments),this.renderOccluded=r.Occlude,this.isDecoration=!1}}const e=8;export{t as VisualVariablePassParameters,e as vvColorNumber};
